import { IReviewPhotoSummary } from '../../types/ReviewTypes';
import { ssFetchJSON } from '../ssFetch';

export function getReviewPhotoSummary(
  providerId?: number,
  pageUrl?: string,
): Promise<IReviewPhotoSummary> {
  if (!providerId && !pageUrl) {
    throw new Error('Error, either page url or provider id must be specified');
  }

  const url = pageUrl || `/api/v2/providers/${providerId}/ratings-photo-summary/`;
  return ssFetchJSON(url);
}
